module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "infraestructura"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row main-content"
  }, [_c('div', {
    staticClass: "small-title-top pull-left"
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.state.title)
    }
  }), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "destinos-main-container",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.state.subTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 map-container",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "myCarousel",
      "data-ride": "carousel"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner"
  }, [_c('div', {
    staticClass: "item active"
  }, [_c('img', {
    staticStyle: {
      "width": "85%",
      "margin": "auto",
      "top": "-100px"
    },
    attrs: {
      "src": _vm.imgUrl(_vm.state.imgInv1),
      "alt": "Los Angeles"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticStyle: {
      "width": "85%",
      "margin": "auto",
      "top": "-100px"
    },
    attrs: {
      "src": _vm.imgUrl(_vm.state.imgInv2),
      "alt": "Los Angeles"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticStyle: {
      "width": "85%",
      "margin": "auto",
      "top": "-100px"
    },
    attrs: {
      "src": _vm.imgUrl(_vm.state.imgInv3),
      "alt": "Los Angeles"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticStyle: {
      "width": "85%",
      "margin": "auto",
      "top": "-100px"
    },
    attrs: {
      "src": _vm.imgUrl(_vm.state.imgInv4),
      "alt": "Los Angeles"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticStyle: {
      "width": "85%",
      "margin": "auto",
      "top": "-100px"
    },
    attrs: {
      "src": _vm.imgUrl(_vm.state.imgInv5),
      "alt": "Los Angeles"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticStyle: {
      "width": "85%",
      "margin": "auto",
      "top": "-100px"
    },
    attrs: {
      "src": _vm.imgUrl(_vm.state.imgInv6),
      "alt": "Los Angeles"
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 footer-container",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/contacto",
      "tag": "a"
    }
  }, [_c('h3', [_vm._v("CONTÁCTANOS")])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border-top": "1px solid white"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Copy right @2017 - All Rights Reserved")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "carousel-indicators"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "data-target": "#myCarousel",
      "data-slide-to": "0"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#myCarousel",
      "data-slide-to": "1"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#myCarousel",
      "data-slide-to": "2"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#myCarousel",
      "data-slide-to": "3"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#myCarousel",
      "data-slide-to": "4"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#myCarousel",
      "data-slide-to": "5"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "left carousel-control",
    attrs: {
      "href": "#myCarousel",
      "data-slide": "prev"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Previous")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "right carousel-control",
    attrs: {
      "href": "#myCarousel",
      "data-slide": "next"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 video-container",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_c('iframe', {
    staticStyle: {
      "margin-top": "80px",
      "margin-bottom": "60px"
    },
    attrs: {
      "src": "https://www.youtube.com/embed/IkrArzW-96M?rel=0&showinfo=0",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e6e7ac3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/infraestructura/infraestructura.vue
// module id = 147
// module chunks = 0